// Home.js
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

import Title from "../components/Title/Title";
import LinkedList from "../components/LinkedList/LinkedList";

const Home = () => {
  return (
    <div className="container py-4">
      <div className="row">
           <div className="col-12 col-md-3">
          <Title weight="400">PRODUCT / ART DIRECTOR <br/> LONDON, UK </Title>
          <LinkedList
            items={[
              {
                label: "EMAIL: CONTACT@STEVENROBERTS.INFO",
                to: "mailto:contact@stevenroberts.info",
              }
            ]}
          />
        </div>
        <div className="col-12 col-md-2">
          <Title weight="600">
            PRODUCTS
          </Title>
          <LinkedList
            items={[
              {
                label: "SEASON SIX GAMES",
                to: "http://seasonsixgames.com/",
              },
              {
                label: "ARENA AMBUSH (GAME)",
                to: "https://glistening-sfogliatella-34d3ec.netlify.app/",
              },
              {
                label: "MINNI MAP",
                to: "https://minnimap.com/",
              },
              {
                label: "TRAYBAKE",
                to: "/",
              },
            ]}
          />

        </div>

        <div className="col-12 col-md-2">
          <Title weight="600">
            ART DIRECTION
          </Title>
          <LinkedList
            items={[
              {
                label: "THE YELLOW WALL-PAPER (FILM)",
                to: "https://drive.google.com/file/d/1xW2Ld_x5AJNt3wY8RydLztu7Qbgy544U/view",
              },
              {
                label: "Beacon in the Abyss",
                to: "https://www.artstation.com/artwork/a0aaGq",
              }
            ]}
          />
        </div>
      </div>
    </div>
  );
};

export default Home;
